import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { co, em } from '@fullcalendar/core/internal-common';
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DisposService } from 'src/app/services/dispos/dispos.service';
import { AuthenticateService } from 'src/app/core/services/user/authenticate.service';
import { getFirebaseBackend } from 'src/app/authUtils';
import { DataService } from 'src/app/core/services/data.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/core/models/user';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { RingcentralService } from 'src/app/services/ringcentral/ringcentral.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import { UserService } from 'src/app/services/user/user.service';
import { TITLES } from 'src/app/shared/constants';
import { TIMEZONES } from 'src/app/views/timezones';

const US_TIMEZONE_VALUES = new Set(['Hawaiian Standard Time', 'Alaskan Standard Time', 'Pacific Standard Time', 'Pacific Daylight Time', 'US Mountain Standard Time', 'Mountain Standard Time', 'Central Standard Time', 'Eastern Standard Time', 'Eastern Daylight Time', 'US Eastern Standard Time', 'Atlantic Standard Time', 'Atlantic Daylight Time']);
import * as moment from 'moment';
import { first } from 'rxjs-compat/operator/first';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
//import { parse } from 'path';

dayjs.extend(utc);
dayjs.extend(timezone);

declare var bootstrap: any;
@Component({
	selector: 'app-appointment-form',
	templateUrl: './appointment-form.component.html',
	styleUrls: ['./appointment-form.component.scss'],
})
export class AppointmentFormComponent implements OnInit {
	appointmentForm!: FormGroup;
	prospectData: any;
	public activeCampaigns: any = [];
	public appt_campaign: any;
	public user: User = null;
	public selectedCallbackDate: dayjs.Dayjs;
	public prospect: any = null;

	months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	times = ['08:00 AM', '08:30 AM', '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '01:00 PM', '01:30 PM', '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM'];

	// TODO: Replace with actual user data
	qc_note = '';
	rc_call_id = '';
	@Input() isReset: string = 'F';
	calificado: boolean = false;
	campaign;
	campaignId: string;
	campaignAlias: string;
	selectedCall: any = null;

	recentCalls = [];
	public titles = TITLES;
	minDate: string;
	isLoading = false;

	usTimezones;

	otherTimezones;

	currentYear = new Date().getFullYear();
	years: number[] = [];

	mapUrl: SafeResourceUrl;

	constructor(
		private fb: FormBuilder,
		public authenticationSrv: AuthenticationService,
		private router: Router,
		private http: HttpClient,
		private disposSrv: DisposService,
		private route: ActivatedRoute,
		private dataSrv: DataService,
		private campaignsSrv: CampaignsService,
		private prospectsSrv: ProspectsService,
		private ringcentralSrv: RingcentralService,
		private modalSrv: NgbModal,
		private userSrv: UserService,
		private sanitizer: DomSanitizer,
	) {
		const nav = this.router.getCurrentNavigation();
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.prospectData = nav?.extras?.state?.['prospectData'] || null;
		this.usTimezones = TIMEZONES.filter((tz) => US_TIMEZONE_VALUES.has(tz.value)).sort((a, b) => a.text.localeCompare(b.text));
		this.otherTimezones = TIMEZONES.filter((tz) => !US_TIMEZONE_VALUES.has(tz.value)).sort((a, b) => a.text.localeCompare(b.text));
	}
	ngOnInit() {
		this.appointmentForm = this.fb.group({
			date: [''],
			companyName: [''],
			time: [''],
			timezone: [''],
			callId: [''],
			campaign_id: [''],
			title: [''],
			first_name: [''],
			provider_1: [''],
			employee_size: [''],
			plan_assets: [''],
			meetType: [''],
			direct_line: [''],
			extension: [''],
			renewalMonth: [''],
			renewalYear: [''],
			email: [''],
			notes: [''],
		});

		const startYear = this.currentYear - 3;
		const endYear = this.currentYear + 10;

		for (let y = startYear; y <= endYear; y++) {
			this.years.push(y);
		}

		const today = new Date();
		this.minDate = today.toISOString().split('T')[0];

		const stateData = history.state?.prospectData;

		this.route.paramMap.subscribe((params) => {
			const campaignId = params.get('campaign_id');
			const alias = params.get('alias');

			this.prospectsSrv.currentCampaignId = campaignId;
			this.prospectsSrv.currentCampaignAlias = alias;
			this.prospectData = stateData ||
				this.prospectsSrv.getCurrentProspect() || {
					campaign_id: campaignId,
					alias: alias,
				};

			this.campaignAlias = alias;
			if (this.prospectData) {
				this.appointmentForm.patchValue({
					first_name: this.prospectData.first_name || '',
					companyName: this.prospectData.company_name || '',
					title: this.prospectData.title || '',
					email: this.prospectData.primary_email || '',
					employee_size: this.prospectData.employee_size || '',
					notes: this.prospectData.notes || '',
					provider_1: this.prospectData.provider_1 || '',
					direct_line: this.prospectData.direct_line || '',
					renewalMonth: this.prospectData.renewal_month_1 || '',
					renewalYear: this.prospectData.renewal_year_1 || '',
					plan_assets: this.prospectData.plan_assets || '',
					campaign_id: this.prospectData.campaign_id || '',
					extension: this.prospectData.extension || '',
				});
			}
			this.getActiveCampaigns();
			this.setMeetTypeFromDispo(this.prospectData?.dispo || '');
			this.buildMapUrl();
		});
	}

	private buildMapUrl(): void {
		const addressParts = [this.prospectData?.address_1, this.prospectData?.address_2, this.prospectData?.city, this.prospectData?.state, this.prospectData?.zip].filter((part) => !!part);
		const query = addressParts.length ? addressParts.join(', ') : 'Brooklyn';
		const url = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&t=&z=13&ie=UTF8&iwloc=&output=embed`;
		this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}

	getId(): void {
		const id = Math.random().toString(36).substring(2, 7);
		this.appointmentForm.patchValue({ callId: id });
	}

	goBack(): void {
		if (!this.prospectData?.campaign_id || !this.prospectData?.campaign_alias) {
			console.error('Datos incompletos:', this.prospectData);
			return;
		}

		const mergedData = {
			...this.prospectData,
			...this.appointmentForm.value,
		};

		this.router.navigate(['/choose-dispo', this.prospectData.campaign_id, this.prospectData.campaign_alias], {
			state: { prospectData: mergedData },
		});
	}

	onExit(): void {
		Swal.fire({
			title: 'Exit this campaign?',
			text: 'Are you sure you want to leave this section?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, exit',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.assign('/');
			}
		});
	}
	onSubmit(): void {
		if (!this.prospectData) {
			Swal.fire('Error', 'No hay datos del prospecto disponibles', 'error');
			return;
		}

		const formValues = this.appointmentForm.value;
		if (!formValues.date || !formValues.time) {
			Swal.fire('Warning', 'No date or time selected for the callback.', 'warning');
			return;
		}
		this.isLoading = true;
		const generated_date = new Date(formValues.date + ' ' + formValues.time);
		const callbackDateStr = dayjs(generated_date).format('YYYY-MM-DD HH:mm:ss');
		let appt_date = dayjs(generated_date);

		if (appt_date.isBefore(dayjs())) {
			appt_date = appt_date.add(1, 'year');
		}

		//Payload para guardar dispo
		const dispoPayload = {
			prospect: this.prospectData.prospectId,
			primary_phone: this.prospectData.primary_phone,
			dispo: this.meetTypeToDispo(formValues.meetType) || this.prospectData.dispo,
			userId: (this.user as any)?.IdUser ?? 0,
			campaign: formValues.campaign_id || this.prospectData.campaignId,
			date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
			callback_date: callbackDateStr,
			notes: formValues.notes || this.prospectData.notes || '',
			create_callback: false,
		};

		//Payload para guardar lead
		const leadPayload = {
			payed: 0,
			met: 'no',
			received_date: null,
			overproduced: 0,
			prospect: this.prospectData.prospectId,
			campaign_id: parseInt(formValues.campaign_id || this.prospectData.campaign_id),
			first_name: formValues.first_name || this.prospectData.first_name,
			last_name: formValues.last_name || this.prospectData.last_name,
			title: formValues.title || this.prospectData.title,
			direct_line: formValues.direct_line || this.prospectData.direct_line,
			ext: formValues.extension || this.prospectData.extension,
			mobile_phone: this.prospectData.mobile_phone,
			email: formValues.email || this.prospectData.primary_email,
			company_name: this.prospectData.company_name,
			alt_contact: this.prospectData.alt_contact,
			alt_phone: this.prospectData.alt_phone,
			EIN: this.prospectData.ein,
			form_5500: this.prospectData.form_5500,
			address_1: this.prospectData.address_1,
			address_2: this.prospectData.address_2,
			state: this.prospectData.state,
			zip: this.prospectData.zip,
			city: this.prospectData.city,
			website_url: this.prospectData.website_url,
			employee_size: formValues.employee_size || this.prospectData.employee_size,
			annual_revenue: this.prospectData.annual_revenue,
			plan_assets: formValues.plan_assets || this.prospectData.plan_assets,
			plan_participants: this.prospectData.plan_participants,
			provider_1: formValues.provider_1 || this.prospectData.provider_1,
			provider_2: this.prospectData.provider_2,
			renewal_month_1: formValues.renewal_month_1 || this.prospectData.renewal_month_1,
			renewal_year_1: this.prospectData.renewal_year_1,
			renewal_month_2: this.prospectData.renewal_month_2,
			renewal_year_2: this.prospectData.renewal_year_2,
			status: 1,
			lead_creation: dayjs().format('YYYY-MM-DD HH:mm:ss'),
			generated_by: this.user.IdUser,
			notes: formValues.notes || this.prospectData.notes,
			qc_notes: this.qc_note,
			client_notes: '',
			write_client_notes: '',
			employee_id: this.user.IdUser,
			employee_login: this.user.Login,
			meet_type: formValues.meetType || this.prospectData.meet_type,
			calificado: this.calificado ? 1 : 0,
			rc_call_id: formValues.callId,
			isReset: this.isReset ? 1 : 0,
			timezone: this.appointmentForm.value.timezone,
			primary_phone: this.prospectData.primary_phone,
			business_code: this.prospectData.business_code,
			business_code_description: this.prospectData.business_code_description,
			date_generated: appt_date.format('YYYY-MM-DD HH:mm:ss'),
		};

		this.disposSrv.saveDispo(dispoPayload).subscribe({
			next: (res: any) => {
				if (res.success) {
					const saveDispoId = res.insertId ? parseInt(res.insertId, 10) : null;
					(leadPayload as any).dispo_id = saveDispoId;

					this.saveCalendarBeforeLead(leadPayload, appt_date).subscribe({
						next: (resCal: any) => {
							const calendarId = resCal.id || resCal?.body?.id || null;
							if (!calendarId) {
								console.error('No se recibió calendarId en la respuesta');
								return;
							}

							(leadPayload as any).calendar = calendarId;

							this.disposSrv.saveLead(leadPayload).subscribe({
								next: (resLead: any) => {
									if (resLead.success) {
										const updatedProspect = { ...this.prospectData, ...formValues };

										this.disposSrv.updateProspect(updatedProspect).subscribe({
											next: (resUpdate: any) => {
												console.info('Prospect updated successfully:', resUpdate);
											},
											error: (errUpdate) => {
												console.error('Error updating prospect:', errUpdate);
											},
										});
										const primaryPhone = this.prospectData.primary_phone || '';
										this.userSrv.saveAction('Lead saved, Primary Phone:' + primaryPhone);

										const leadsNeeded = resLead.body?.leads_needed ?? null;

										Swal.fire('✅ Success', 'Lead saved successfully.', 'success').then(() => {
											if (leadsNeeded !== null && leadsNeeded <= 0) {
												Swal.fire('⚠️ Atención', 'The campaign needs no more leads.', 'warning').then(() => {
													this.router.navigate(['/']);
												});
											} else {
												this.router.navigate(['/prospect-info', this.prospectsSrv.currentCampaignId, this.prospectsSrv.currentCampaignAlias]).then(() => {
													window.location.reload();
												});
											}
										});
									} else {
										Swal.fire('❌ Error', resLead.res?.message || 'Could not save the lead', 'error');
									}
									this.isLoading = false;
								},
								error: (err) => {
									console.error('❌ Error saving lead:', err);
									Swal.fire('Error', 'There was a problem saving the lead', 'error');
									this.isLoading = false;
								},
							});
						},
						error: (errCal) => {
							console.error('❌ Error saving calendar:', errCal);
							Swal.fire('Error', 'There was a problem saving the calendar', 'error');
							this.isLoading = false;
						},
					});
				} else {
					Swal.fire('❌ Error', res.res?.message || 'Could not save the dispo', 'error');
					this.isLoading = false;
				}
			},
			error: (err) => {
				console.error('❌ Error saving dispo:', err);
				Swal.fire('Error', 'There was a problem saving the dispo', 'error');
				this.isLoading = false;
			},
		});
	}

	getActiveCampaigns() {
		const isActive = '1';
		this.campaignsSrv.getCampaignsForSelect(isActive).subscribe({
			next: (data: any) => {
				this.activeCampaigns = Array.isArray(data?.body) ? data.body : [];

				if (this.prospectData?.campaign_id) {
					this.appointmentForm.patchValue({ campaign: this.prospectData.campaign_id });
				}

				this.setTimezoneForCampaign(this.prospectData?.campaign_id);

				this.appointmentForm.get('campaign_id')?.valueChanges.subscribe((campaignId) => {
					this.setTimezoneForCampaign(campaignId);
				});

				if (!data || this.activeCampaigns.length === 0) {
					console.warn('No campaigns returned from API');
				}
			},
			error: (err) => {
				console.error('Error fetching active campaigns:', err);
				this.activeCampaigns = [];
			},
		});
	}

	private setTimezoneForCampaign(campaignId: any): void {
		if (!campaignId) return;

		// The initial campaign's timezone already came from choose-dispo (which already
		// fetches get_campaign_and_info before navigating here), so reuse it instead of
		// firing a duplicate request. Only campaigns picked later need a fresh lookup.
		if (campaignId == this.prospectData?.campaign_id && this.prospectData?.campaign_timezone) {
			this.applyTimezone(this.prospectData.campaign_timezone);
			return;
		}

		this.campaignsSrv.getCampaignAndInfoById(campaignId).subscribe({
			next: (res: any) => this.applyTimezone(res?.body?.timezone),
			error: (err) => {
				console.error('Error fetching campaign info for timezone:', err);
			},
		});
	}

	private applyTimezone(campaignTimezone: string): void {
		if (!campaignTimezone) return;

		const tz = TIMEZONES.find((t) => t.abbr === campaignTimezone);
		if (tz) {
			this.appointmentForm.patchValue({ timezone: tz.abbr });
		}
	}

	getRingCentralCalls() {
		console.log(this.user);
		const payload = { extId: this.user.rc_ext_id };
		this.ringcentralSrv.getRingCentralCalls(payload).subscribe({
			next: (data: any) => {
				this.recentCalls = data.success;
			},
			error: (err) => {
				console.error('Error fetching active campaigns:', err);
			},
		});
	}

	openModal(content: any) {
		this.modalSrv.open(content, { centered: true, size: 'lg' });
		this.getRingCentralCalls();
	}

	formatDuration(seconds: number): string {
		if (!seconds) return '';

		if (seconds < 60) {
			return `${seconds} sec`;
		} else if (seconds < 3600) {
			const minutes = Math.floor(seconds / 60);
			const remainingSec = seconds % 60;
			return remainingSec > 0 ? `${minutes} min ${remainingSec} sec` : `${minutes} min`;
		} else {
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			return minutes > 0 ? `${hours} h ${minutes} min` : `${hours} h`;
		}
	}
	onSelectCall(call: any) {
		this.selectedCall = call;
	}

	setMeetTypeFromDispo(dispo: string): void {
		let meetTypeValue: string | null = null;

		switch (dispo.toUpperCase()) {
			case 'FACE':
			case 'FACE TO FACE':
			case 'IN PERSON':
				meetTypeValue = '1';
				break;
			case 'PHONE':
			case 'CALL':
			case 'PHONE CALL':
				meetTypeValue = '2';
				break;
			case 'ZOOM':
			case 'ZOOM CALL':
			case 'VIDEO':
				meetTypeValue = '3';
				break;
			default:
				meetTypeValue = null;
				break;
		}

		if (meetTypeValue) {
			setTimeout(() => {
				this.appointmentForm.patchValue({ meetType: meetTypeValue });
			}, 0);
		}
	}

	private meetTypeToDispo(meetType: string): string | null {
		switch (meetType) {
			case '1':
				return 'FACE';
			case '2':
				return 'PHONE';
			case '3':
				return 'ZOOM';
			default:
				return null;
		}
	}

	selectCallId(callId: string) {
		this.appointmentForm.get('callId')?.setValue(callId);

		this.modalSrv.dismissAll();
	}

	saveCalendarBeforeLead(leadPayload: any, appt_date: dayjs.Dayjs) {
		const calendar = {
			type: leadPayload.meet_type,
			campaign: leadPayload.campaign_id,
			start_date: appt_date.format('YYYY-MM-DD'),
			start_time: appt_date.format('HH:mm:ss'),
			end_date: appt_date.add(2, 'hours').format('YYYY-MM-DD'),
			end_time: appt_date.add(2, 'hours').format('HH:mm:ss'),
			timezone: this.appointmentForm.value.timezone,
		};

		return this.disposSrv.saveCalendar(calendar);
	}

	parseTime12h(timeStr: string): [number, number] {
		const [time, modifier] = timeStr.split(' ');
		let [hours, minutes] = time.split(':').map(Number);

		if (modifier === 'PM' && hours < 12) {
			hours += 12;
		}
		if (modifier === 'AM' && hours === 12) {
			hours = 0;
		}
		return [hours, minutes];
	}
}
